/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseTrianglesHOpenIcon16Light } from './ArrowCollapseTrianglesHOpenIcon16Light';
import { ArrowCollapseTrianglesHOpenIcon16Regular } from './ArrowCollapseTrianglesHOpenIcon16Regular';
import { ArrowCollapseTrianglesHOpenIcon16Solid } from './ArrowCollapseTrianglesHOpenIcon16Solid';
import { ArrowCollapseTrianglesHOpenIcon20Light } from './ArrowCollapseTrianglesHOpenIcon20Light';
import { ArrowCollapseTrianglesHOpenIcon20Regular } from './ArrowCollapseTrianglesHOpenIcon20Regular';
import { ArrowCollapseTrianglesHOpenIcon20Solid } from './ArrowCollapseTrianglesHOpenIcon20Solid';
import { ArrowCollapseTrianglesHOpenIcon24Regular } from './ArrowCollapseTrianglesHOpenIcon24Regular';
import { ArrowCollapseTrianglesHOpenIcon24Solid } from './ArrowCollapseTrianglesHOpenIcon24Solid';
import { ArrowCollapseTrianglesHOpenIcon32Regular } from './ArrowCollapseTrianglesHOpenIcon32Regular';
import { ArrowCollapseTrianglesHOpenIcon64Regular } from './ArrowCollapseTrianglesHOpenIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseTrianglesHOpenIcon16Light,
        regular: ArrowCollapseTrianglesHOpenIcon16Regular,
        solid: ArrowCollapseTrianglesHOpenIcon16Solid,
    },
    20: {
        light: ArrowCollapseTrianglesHOpenIcon20Light,
        regular: ArrowCollapseTrianglesHOpenIcon20Regular,
        solid: ArrowCollapseTrianglesHOpenIcon20Solid,
    },
    24: {
        regular: ArrowCollapseTrianglesHOpenIcon24Regular,
        solid: ArrowCollapseTrianglesHOpenIcon24Solid,
    },
    32: {
        regular: ArrowCollapseTrianglesHOpenIcon32Regular,
    },
    64: {
        regular: ArrowCollapseTrianglesHOpenIcon64Regular,
    },
};
export var ArrowCollapseTrianglesHOpenIcon = forwardRef('ArrowCollapseTrianglesHOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
